













import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  components: {},
})

export default class ChatPicture extends Vue {
  @Prop({default: () => []})
  isSent: string | undefined
  @Prop({default: () => []})
  avatarUrl: string | undefined
  @Prop({default: () => []})
  filePreviewUrl: string | undefined

  private mounted() {
    console.log(this.isSent);
    console.log(this.isSent !== null ? '.leftStyle' : 'rightStyle');

  }
}
